import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Zap } from 'lucide-react';
import { API } from '../api/client';

const typeColor = { T: 'chip-t', R: 'chip-r', M: 'chip-m', D: 'chip-d' };
const pricingLabel = {
  free: 'Free',
  freemium: 'Freemium',
  paid: 'Paid',
  'open-source': 'Open source',
  unknown: '',
};

export default function ToolCard({ tool }) {
  const label = pricingLabel[tool.pricing_type] || '';
  const chip = typeColor[tool.type_code] || 'chip-t';
  const initial = (tool.name || '?').trim().charAt(0).toUpperCase();

  return (
    <div className="tool-card">
      <Link to={`/tool/${tool.slug}`} className="tool-card-body">
        <div className="tool-logo" aria-hidden>
          {tool.logo ? (
            <img src={tool.logo} alt="" />
          ) : (
            <span className="tool-logo-fallback">{initial}</span>
          )}
        </div>
        <div className="tool-info">
          <div className="tool-title-row">
            <h3 className="tool-title">{tool.name}</h3>
            {tool.sponsored && <span className="badge sponsored"><Zap size={10} /> Sponsored</span>}
          </div>
          <p className="tool-desc">{tool.short_description || tool.primary_category}</p>
          <div className="tool-meta">
            {label && <span className={`badge ${chip}`}>{label}</span>}
            {tool.featured && <span className="badge featured">Featured</span>}
            <span className="tool-cat">{tool.primary_category}</span>
            {tool.click_count > 0 && (
              <span className="tool-clicks">{tool.click_count.toLocaleString()} clicks</span>
            )}
          </div>
        </div>
      </Link>
      <a
        className="tool-visit"
        href={`${API}/go/${tool.slug}?ref=/`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Visit ${tool.name}`}
      >
        Visit <ExternalLink size={12} />
      </a>
    </div>
  );
}
